/*eslint-disable*/ export const messages = JSON.parse("{\"page-indicator.aria.label\":[\"Prikk \",[\"selectedPage\"],\" er uthevet i en rad med \",[\"pageCount\"],\" prikker\"]}");
//# sourceMappingURL=messages.mjs.map